import { Select, Flex, Radio, Button, Tooltip } from "antd";
import React, { forwardRef, useEffect, useState } from "react";
import commonFn from "@/utils/commonFn";
import http from "@/utils/http";
import api from "@/utils/api";

import { SyncOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { CustomTable } from "@/hocComponents";

const MaintenceMain = forwardRef(() => {
  const [vendorList, setVendorList] = useState([]);
  const [vendorIdList, setVendorIdList] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [accountIdList, setAccountIdList] = useState([]);

  const initTableHead = {};
  const [tableHead, setTableHead] = useState(initTableHead);

//   const tableFilterFn = (event, key, type = "Input") => {
//     commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
//   };

  const renderCountFn = (count, maintenanceIdList, { route, noSet } = {}) => {
    const flag = maintenanceIdList?.length;
    return (
      <span
        style={{
          color: flag ? "#0e78a9" : "inherit",
          cursor: flag ? "pointer" : "default",
        }}
        onClick={() =>
          flag && maintenanceIdListClickFn(maintenanceIdList.join("%2C"), route)
        }
      >
        {noSet || flag ? count : "-"}
      </span>
    );
  };

  const monthColumnsListFn = ({ title, propsKey, key }) => {
    return {
      title: (
        <>
          {title}
          <Tooltip title="Assigned - Complete = Not Complete">
            <InfoCircleOutlined style={{ marginLeft: 4, color: "#999" }} />
          </Tooltip>
        </>
      ),
      dataIndex: key,
      align: "center",
      titleType: "",
      render: (_, record) => {
        const {
          completedCount,
          completedIds,
          outstandingCount,
          outstandingIds,
          totalCount,
          totalIds,
        } = record?.[propsKey]?.[key] || {};
        const doc = renderCountFn(outstandingCount, outstandingIds, {
          noSet: true,
        });
        if (
          completedIds?.length ||
          outstandingIds?.length ||
          totalIds?.length
        ) {
          return (
            <>
              {totalCount} - {completedCount} = {doc}
            </>
          );
        }
        return "-";
      },
    };
  };

  const initColumns = [
    {
      title: "Vendor Name",
      dataIndex: "vendorName",
      titleType: "",
      width: 200,
    },
    {
      title: "Supervisor Name",
      dataIndex: "supervisorName",
      titleType: "",
      width: 200,
    },
    {
      title: "Maint.Worker",
      dataIndex: "vendorType",
      titleType: "",
      width: 100,
    },
    {
      title: "Total Outstanding Requests",
      dataIndex: "totalOutstandingRequests",
      titleType: "",
      render: (_, record) => {
        const { count, maintenanceIdList } =
          record?.head?.["totalOutstandingRequests"] || {};
        return renderCountFn(count, maintenanceIdList);
      },
    },
    monthColumnsListFn({
      title: "1-15 Days",
      propsKey: "head",
      key: "days1to15",
    }),
    monthColumnsListFn({
      title: "16-30 Days",
      propsKey: "head",
      key: "days16to30",
    }),
    {
      title: "Older OT",
      dataIndex: "olderOt",
      titleType: "",
      width: 80,
      render: (_, record) => {
        const { count, maintenanceIdList } = record?.head?.["olderOt"] || {};
        return renderCountFn(count, maintenanceIdList);
      },
    },
    {
      title: "Total Completed Jobs",
      dataIndex: "totalCompletedJob",
      titleType: "",
      render: (_, record) => {
        const { count, maintenanceIdList } =
          record?.head?.["totalCompletedJob"] || {};
        return renderCountFn(count, maintenanceIdList, {
          route: "/JobRequests/MaintenanceHistory",
        });
      },
    },
    {
      title: "Vendor Phone",
      dataIndex: "vendorPhone",
      titleType: "",
      width: 140,
      render: (_, record) => {
        return record?.head?.["vendorPhone"];
      },
    },
    {
      title: "Monthly Rate",
      dataIndex: "monthlyRate",
      titleType: "",
      render: (_, record) => {
        return commonFn.amountToDollarFn(record?.head?.["monthlyRate"]);
      },
    },
  ];

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  //列表
  const getTableListFn = async (tableHead = {}, isFirst) => {
    if (!isFirst) {
      setTableLoading(true);
    }
    const response = await http.get(api.maintenanceVendorCostReport, {
      params: { ...tableHead, vendorIdList: String(vendorIdList), accountIdList: String(accountIdList) },
    });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response);
      setTableLoading(false);
      return;
    }
    const monthList = response.data?.titleDate || [];

    const monthColumnsList = monthList.flatMap((item) => {
      return [
        monthColumnsListFn({ title: item, propsKey: "tail", key: item }),
        {
          title: "Per Request Charge",
          dataIndex: "unitPrice",
          titleType: "",
            render: (_, record) => {
                return commonFn.amountToDollarFn(record?.tail?.[item]?.['unitPrice']);
            },
        },
      ];
    });
    setColumns([...initColumns, ...monthColumnsList]);
    setTableList(response.data?.startList || []);
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(tableHead);
  };

  const maintenanceIdListClickFn = (
    ids,
    route = "/JobRequests/Maintenance"
  ) => {
    const url = `${window.location.origin}#${route}?ids=${ids}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const maintenanceVendorListFn = async () => {
    const response = await http.get(api.maintenanceVendorList);
    if (response?.code === "1") {
      const list = response?.data?.map((item) => ({
        value: item.vendorId,
        label: item.name,
      }));
      setVendorList([{ value: -1, label: "All" }, ...list]);
    }
  };

  const maintenanceAccountListFn = async () => {
    const response = await http.get(api.getSupervisorList);
    if (response?.code === "1") {
      const list = response?.data?.map((item) => ({
        value: item.accountId,
        label: item.fullName,
      }));
      setAccountList([{ value: "", label: "All" }, ...list]);
    }
  };

  // 初始化函数
  useEffect(() => {
    getTableListFn({}, true);
    maintenanceVendorListFn();
    maintenanceAccountListFn()
  }, [refreshKey]);

  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="center">
        {/* 左边筛选条件 */}
        <Flex align="center" gap={12}>
          <div>
            <span style={{ marginRight: 8 }}>Vendor Name:</span>
            <Select
              mode="multiple"
              showSearch
              allowClear
              placeholder="Select a Vendor Name"
              value={vendorIdList}
              onChange={(list) => setVendorIdList(list)}
              style={{ width: 380, textAlign: "left" }}
              options={vendorList}
              optionFilterProp="label"
              className="supervisor-select"
            />
          </div>

          <div>
            <span style={{ marginRight: 8 }}>Supervisor:</span>
            <Select
              mode="multiple"
              showSearch
              allowClear
              placeholder="Select a Supervisor"
              value={accountIdList}
              onChange={(list) => setAccountIdList(list)}
              style={{ width: 380, textAlign: "left" }}
              options={accountList}
              optionFilterProp="label"
              className="supervisor-select"
            />
          </div>

          <Button
            type="primary"
            onClick={() => getTableListFn({})}
            loading={tableLoading}
          >
            Submit
          </Button>

        </Flex>

        {/* 右边刷新按钮 */}
        <Radio.Group defaultValue="a" size="middle">
          <Radio.Button value="a" onClick={() => setRefreshKey(+new Date())}>
            <SyncOutlined />
          </Radio.Button>
        </Radio.Group>
      </Flex>
      <CustomTable
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowKey="accountId"
        columns={columns}
        tableList={tableList}
        pagination={false}
        bordered={true}
        handleTableChange={handleTableChange}
        tableScrollY="350px"
        tableCss="maintenance-vendorCostReport-Table"
      />
    </div>
  );
});
export default MaintenceMain;
